import pushyService from "./index";
import toast from "react-hot-toast";

export const registerDevice = async (sendDeviceToken) => {
  try {
    await pushyService.register(sendDeviceToken);
    return true;
  } catch (error) {
    toast("Включите Push-уведомления в настройках браузера/устройства!", {
      duration: 6000,
      style: { textAlign: "center" },
    });
    return false;
  }
};
